/* ==========================================================================
   markendruckerei — Progressive Enhancement (statisch, lokal, kein Framework)
   Ohne JS bleibt die Site voll sichtbar & bedienbar. JS fügt nur Bewegung +
   Zustände hinzu. Respektiert prefers-reduced-motion.
   ========================================================================== */
(function () {
  var root = document.documentElement;
  // Früh (blockend im <head>) gesetzt → kein Flash: CSS versteckt Reveals nur unter .js
  if (root.className.indexOf("js") === -1) root.className += " js";

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function onReady(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  onReady(function () {
    /* --- Aktiver Nav-Zustand: markiert die Seite, auf der man ist --------- */
    var here = (location.pathname.split("/").pop() || "index.html");
    if (here === "") here = "index.html";
    document.querySelectorAll(".nav a[href]").forEach(function (a) {
      var target = a.getAttribute("href").split("/").pop().split("#")[0];
      if (target === here && !a.classList.contains("nav-cta")) {
        a.setAttribute("aria-current", "page");
      }
    });

    /* --- Header verdichtet sich beim Scrollen ---------------------------- */
    var header = document.querySelector(".site-header");
    if (header) {
      var onScroll = function () {
        if (window.scrollY > 8) header.classList.add("is-scrolled");
        else header.classList.remove("is-scrolled");
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }

    /* --- Mobile-Nav: Hamburger (Progressive Enhancement) ---------------- */
    // Baut die Nav unter 760px zu einem ausklappbaren Panel um und ergänzt eine
    // persistente „Projekt anfragen"-CTA im Header-Balken. Ohne JS greift die
    // klassische gestackte Nav (CSS-Fallback). Läuft VOR dem reduced-motion-return.
    var headerWrap = document.querySelector(".site-header .wrap");
    var nav = document.querySelector(".site-header .nav");
    if (headerWrap && nav) {
      if (!nav.id) nav.id = "primary-nav";

      // Persistente Mobile-CTA (spiegelt die vorhandene nav-cta)
      var srcCta = nav.querySelector(".nav-cta");
      if (srcCta) {
        var mCta = document.createElement("a");
        mCta.href = srcCta.getAttribute("href");
        mCta.className = "btn btn--primary nav-mobile-cta";
        mCta.textContent = srcCta.textContent.trim();
        headerWrap.appendChild(mCta);
      }

      // Hamburger-Button
      var toggle = document.createElement("button");
      toggle.type = "button";
      toggle.className = "nav-toggle";
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-controls", nav.id);
      toggle.setAttribute("aria-label", "Open menu");
      toggle.innerHTML = '<span class="bars" aria-hidden="true"></span>';
      headerWrap.appendChild(toggle);

      var setOpen = function (open) {
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
        if (open) nav.setAttribute("data-open", "true");
        else nav.removeAttribute("data-open");
      };

      toggle.addEventListener("click", function () {
        setOpen(toggle.getAttribute("aria-expanded") !== "true");
      });

      // Escape schließt und gibt Fokus zurück
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
          setOpen(false);
          toggle.focus();
        }
      });

      // Klick außerhalb schließt
      document.addEventListener("click", function (e) {
        if (toggle.getAttribute("aria-expanded") !== "true") return;
        if (nav.contains(e.target) || toggle.contains(e.target)) return;
        setOpen(false);
      });

      // Link im Panel geklickt → schließen
      nav.addEventListener("click", function (e) {
        if (e.target.closest && e.target.closest("a")) setOpen(false);
      });

      // Wechsel auf Desktop-Breite → Zustand zurücksetzen
      var mq = window.matchMedia("(min-width: 760px)");
      var onMq = function () { if (mq.matches) setOpen(false); };
      if (mq.addEventListener) mq.addEventListener("change", onMq);
      else if (mq.addListener) mq.addListener(onMq);
    }

    /* --- Anfrage-Formular: zugängliche Client-Validierung (PE) ---------- */
    // Ohne JS bleibt das Formular normal bedienbar (novalidate greift nur mit JS).
    // Kein Backend im Entwurf: gültige Eingabe zeigt einen Erfolgs-Zustand mit
    // vorbereitetem mailto-Direktweg — es wird nichts automatisch verschickt.
    var form = document.getElementById("anfrage-form");
    if (form) {
      var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      var required = [
        { id: "f-name", empty: "Please enter your name." },
        { id: "f-mail", empty: "Please enter your email address.", bad: "This email address doesn't look complete yet." }
      ];
      var val = function (id) { var el = document.getElementById(id); return el ? (el.value || "").trim() : ""; };
      var errorFor = function (cfg) {
        var v = val(cfg.id);
        if (!v) return cfg.empty;
        if (cfg.bad && !emailRe.test(v)) return cfg.bad;
        return null;
      };
      var showError = function (el, msg) {
        var box = document.getElementById(el.id + "-err");
        el.setAttribute("aria-invalid", "true");
        if (box) { box.textContent = msg; box.hidden = false; }
      };
      var clearError = function (el) {
        var box = document.getElementById(el.id + "-err");
        el.removeAttribute("aria-invalid");
        if (box) box.hidden = true;
      };
      required.forEach(function (cfg) {
        var el = document.getElementById(cfg.id);
        if (!el) return;
        el.addEventListener("input", function () { if (el.getAttribute("aria-invalid") === "true" && !errorFor(cfg)) clearError(el); });
        el.addEventListener("blur", function () { var m = errorFor(cfg); if (m) showError(el, m); });
      });
      // Nur bei Fehlern abbrechen – sonst sendet das native Shopify-Kontaktformular.
      form.addEventListener("submit", function (e) {
        var firstBad = null;
        required.forEach(function (cfg) {
          var el = document.getElementById(cfg.id);
          if (!el) return;
          var msg = errorFor(cfg);
          if (msg) { showError(el, msg); if (!firstBad) firstBad = el; } else clearError(el);
        });
        if (firstBad) { e.preventDefault(); firstBad.focus(); return; }
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = "Sending …"; }
      });
    }
    var ok = document.getElementById("form-ok");
    if (ok) { ok.scrollIntoView({ block: "center" }); ok.focus({ preventScroll: true }); }

    /* --- Sticky Mobile-CTA: erscheint nach dem Hero ---------------------- */
    var mcta = document.querySelector("[data-mcta]");
    if (mcta) {
      var onS = function () { if (window.scrollY > 520) mcta.classList.add("is-on"); else mcta.classList.remove("is-on"); };
      window.addEventListener("scroll", onS, { passive: true }); onS();
    }

    /* --- Kundenwand: gestaffeltes Einblenden --- */
    var cw = document.querySelector(".cw");
    if (cw) {
      cw.querySelectorAll(".cw__n").forEach(function (n, i) { n.style.transitionDelay = (i * 35) + "ms"; });
      if ("IntersectionObserver" in window && !reduce) {
        var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { cw.classList.add("is-in"); cio.disconnect(); } }); }, { threshold: 0.15 });
        cio.observe(cw);
      } else { cw.classList.add("is-in"); }
    }

    /* --- Scroll-Reveal: bewusst, gestaffelt, einmalig -------------------- */
    // Hero wird per CSS beim Laden choreografiert (nicht per Scroll-Reveal)
    var SELECTOR = [
      ".rakel", ".trail",
      ".eyebrow", ".h2", ".lede", ".split > div",
      ".proof__card", ".process__step", ".segment-card", ".case-card", ".sla__step", ".pick", ".cat", ".vs__card", ".ind__card", ".case", ".reason",
      ".cta-band__inner > *",
      ".legal h2", ".legal p", ".legal dl"
    ].join(",");

    var targets = Array.prototype.slice.call(document.querySelectorAll(SELECTOR)).filter(function (el) { return !el.closest("#anfrage"); });

    if (reduce || !("IntersectionObserver" in window)) {
      // Kein Verstecken → alles sofort sichtbar (reduced-motion / alte Browser)
      return;
    }

    targets.forEach(function (el) {
      el.classList.add("reveal");
      // Sanfter Stagger innerhalb einer Gruppe (Karten/Schritte nebeneinander)
      var group = el.parentElement ? el.parentElement.children : [];
      var idx = Array.prototype.indexOf.call(group, el);
      if (idx > 0 && idx < 8) el.style.setProperty("--reveal-delay", (idx * 65) + "ms");
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });

    targets.forEach(function (el) { io.observe(el); });
  });
})();

/* --- Messung: Kontaktabsichten & Haupt-CTA (ohne personenbezogene Daten) --- */
(function(){
  function ev(n,d){try{window.Shopify&&Shopify.analytics&&Shopify.analytics.publish&&Shopify.analytics.publish(n,d||{});}catch(e){} try{(window.dataLayer=window.dataLayer||[]).push(Object.assign({event:n},d||{}));}catch(e){}}
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a'); if(!a) return;
    var h=a.getAttribute('href')||'', where=(a.closest('header')?'header':a.closest('footer')?'footer':a.closest('[data-mcta]')?'mobile_bar':'content'), page=location.pathname;
    if(a.dataset.mdEvt) ev('md_'+a.dataset.mdEvt,{page:page});
    else if(h.indexOf('/en/pages/anfrage')===0) ev('md_cta_anfrage',{where:where,page:page});
    else if(h.indexOf('tel:')===0) ev('md_contact_phone',{where:where,page:page});
    else if(h.indexOf('wa.me')>-1) ev('md_contact_whatsapp',{where:where,page:page});
    else if(h.indexOf('mailto:')===0) ev('md_contact_mail',{where:where,page:page});
  },true);
})();

/* --- Micro-Interactions: Magnetic Buttons, Letter-Swap, Edge-Glow --- */
(function(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  // Letter-Swap in Hauptnavigation
  document.querySelectorAll('.site-header .nav > a:not(.nav-cta):not(.nav__cart)').forEach(function(a){
    var t = a.firstChild; if (!t || t.nodeType !== 3) return;
    var txt = t.textContent.trim(); if (!txt) return;
    var w = document.createElement('span'); w.className = 'lsw'; w.setAttribute('aria-hidden','true');
    txt.split('').forEach(function(c,i){ var s=document.createElement('span'); s.textContent=c; s.setAttribute('data-c',c); s.style.setProperty('--i',i); w.appendChild(s); });
    a.setAttribute('aria-label', a.getAttribute('aria-label') || a.textContent.trim());
    a.replaceChild(w, t);
  });
  if (!fine) return;
  // Magnetic Buttons
  document.querySelectorAll('.btn--primary, .hx__btn').forEach(function(b){
    b.addEventListener('mousemove', function(e){ var r=b.getBoundingClientRect(); b.style.setProperty('--tx',((e.clientX-r.left-r.width/2)*.18)+'px'); b.style.setProperty('--ty',((e.clientY-r.top-r.height/2)*.28)+'px'); });
    b.addEventListener('mouseleave', function(){ b.style.setProperty('--tx','0px'); b.style.setProperty('--ty','0px'); });
  });
  // Edge-Glow auf Karten
  document.querySelectorAll('.pick, .case, .dz-size, .reason, .team-card').forEach(function(c){ if (c.classList.contains('spot')) return;
    c.classList.add('glow');
    c.addEventListener('mousemove', function(e){ var r=c.getBoundingClientRect(); c.style.setProperty('--gx',(e.clientX-r.left)+'px'); c.style.setProperty('--gy',(e.clientY-r.top)+'px'); });
  });
})();

/* --- Stopper: Liefertermin, Antwortzeit, Termin-Check, Preisrechner ---
   Regeln (bestätigt): Antwort werktags in 24 h · Produktion 3–5 WT nach Freigabe · Versand DE meist 1–2 WT. Ohne Feiertage. */
(function(){
  function isWD(d){var x=d.getDay();return x!==0&&x!==6;}
  function addWD(d,n){var r=new Date(d);while(n>0){r.setDate(r.getDate()+1);if(isWD(r))n--;}return r;}
  function nextWD(d){var r=new Date(d);while(!isWD(r))r.setDate(r.getDate()+1);return r;}
  function wdBetween(a,b){var n=0,r=new Date(a);r.setHours(0,0,0,0);var e=new Date(b);e.setHours(0,0,0,0);while(r<e){r.setDate(r.getDate()+1);if(isWD(r))n++;}return n;}
  function subWD(d,n){var r=new Date(d);while(n>0){r.setDate(r.getDate()-1);if(isWD(r))n--;}return r;}
  var fmt=new Intl.DateTimeFormat('en-GB',{weekday:'short',day:'numeric',month:'short'});
  function f(d){return fmt.format(d).replace(',', '');}
  var today=new Date();today.setHours(12,0,0,0);
  var start=isWD(today)?today:nextWD(today);
  // Liefertermin
  var e1=addWD(start,4), e2=addWD(start,7);
  document.querySelectorAll('[data-md-eta]').forEach(function(el){
    el.innerHTML=(isWD(today)?'Approve today':'Approve on Monday')+' → with you around <b>'+f(e1)+' – '+f(e2)+'</b> <small>(Germany, excl. public holidays)</small>';
  });
  // Antwortzeit
  var rep=isWD(today)?addWD(today,1):addWD(nextWD(today),1);
  var diff=Math.round((rep-today)/864e5);
  var repTxt=diff===1?'tomorrow':new Intl.DateTimeFormat('en-GB',{weekday:'long'}).format(rep);
  document.querySelectorAll('[data-md-reply]').forEach(function(el){
    el.innerHTML='Ask today → reply by <b>'+repTxt+'</b>';
  });
  // Termin-Check
  document.querySelectorAll('[data-md-termin]').forEach(function(box){
    var inp=box.querySelector('[data-tc-date]'),res=box.querySelector('[data-tc-res]'),go=box.querySelector('[data-tc-go]');
    var min=new Date();inp.min=min.toISOString().slice(0,10);
    inp.addEventListener('change',function(){
      if(!inp.value){return;}
      var d=new Date(inp.value+'T12:00:00'),n=wdBetween(start,d);box.classList.remove('is-ok','is-tight','is-hot');
      if(n>=8){var dl=subWD(d,7);res.innerHTML='<b>That works.</b> Approve by <b>'+f(dl)+'</b> at the latest and your order arrives in time.';box.classList.add('is-ok');}
      else if(n>=4){res.innerHTML='<b>Tight, but possible.</b> Put the date in your inquiry and we\'ll tell you right away if we can make it.';box.classList.add('is-tight');}
      else{res.innerHTML='<b>Very tight.</b> Best to call us directly: <a href="tel:+4915565654643">+49 155 65 65 46 43</a>';box.classList.add('is-hot');}
      go.hidden=false;var q=new URLSearchParams(location.search);var u='/en/pages/anfrage?termin='+inp.value;go.href=u;
      try{window.Shopify&&Shopify.analytics&&Shopify.analytics.publish('md_termin_check',{wd:n});}catch(e){}
    });
  });
  // Preisrechner (Stufen, ohne Modellwahl)
  document.querySelectorAll('[data-md-calc]').forEach(function(c){
    var dEl=c.parentNode.querySelector('[data-calc-data]')||document.querySelector('[data-calc-data]'); if(!dEl) return;
    var D; try{D=JSON.parse(dEl.textContent);}catch(e){return;}
    var st={c:0,t:'b'};
    var r=c.querySelector('#calc-r'),n=c.querySelector('#calc-n'),b=c.querySelector('#calc-b');
    var catsEl=c.querySelector('[data-calc-cats]'),tierBtns=c.querySelectorAll('[data-tier]');
    var euro=function(x){return (x/100).toLocaleString('en-GB',{style:'currency',currency:'EUR'});};
    var TN={b:'Basic',p:'Premium',s:'Super Premium'};
    function chip(label,on,fn){var x=document.createElement('button');x.type='button';x.className='calc__chip2'+(on?' is-on':'');x.setAttribute('role','radio');x.setAttribute('aria-checked',on);x.innerHTML='<b></b>';x.querySelector('b').textContent=label;x.addEventListener('click',fn);return x;}
    function render(){
      var cat=D.cats[st.c];
      if(!cat.t[st.t]){st.t=['b','p','s'].filter(function(k){return cat.t[k];})[0];}
      catsEl.innerHTML='';D.cats.forEach(function(k,i){catsEl.appendChild(chip(k.n,i===st.c,function(){st.c=i;render();}));});
      tierBtns.forEach(function(tb){var k=tb.dataset.tier,t=cat.t[k];tb.hidden=!t;tb.classList.toggle('is-on',k===st.t);tb.setAttribute('aria-checked',k===st.t);tb.querySelector('[data-from]').textContent=t?euro(t.p):'';});
      c.querySelector('[data-calc-tiers]').dataset.count=['b','p','s'].filter(function(k){return cat.t[k];}).length;
      upd();
    }
    function upd(src){
      var q=Math.max(1,Math.min(2000,parseInt((src==='r'?r:n).value,10)||1));
      if(src==='r')n.value=q; else r.value=Math.min(q,250);
      var cat=D.cats[st.c],m=cat.t[st.t];
      var unit=m.p+(b.checked?500:0);
      var pct=q>=100?15:q>=50?10:q>=25?5:0;
      var pp=Math.round(unit*(100-pct))/100,sum=Math.round(unit*q*(100-pct)/100);
      c.querySelector('[data-calc-model]').innerHTML='<span class="calc__tb calc__tb--'+st.t+'">'+TN[st.t]+'</span> '+cat.s;
      c.querySelector('[data-calc-pp]').textContent=euro(pp);
      c.querySelector('[data-calc-n]').textContent=q+' pcs';
      c.querySelector('[data-calc-disc]').innerHTML=pct?'<b>−'+pct+'&nbsp;%</b>':'from 25 pcs −5&nbsp;%';
      c.querySelector('[data-calc-sum]').textContent=euro(sum);
      c.querySelector('[data-calc-ship]').textContent=sum>=15000?'free (Germany)':'free from €150 (Germany)';
      var desc=c.querySelector('[data-calc-desc]');desc.hidden=!m.d;desc.textContent=m.d||'';
      var nextT=q<25?25:q<50?50:q<100?100:0;
      c.querySelector('[data-calc-note]').innerHTML=nextT?('<b>'+(nextT-q)+' more pcs</b> to the next discount tier.'):'Top discount tier reached.';
      var title=TN[st.t]+' '+cat.s+' ('+m.m+')'+(b.checked?' + back logo':'');
      c.querySelector('[data-calc-offer]').href='/en/pages/anfrage?produkt='+encodeURIComponent(title)+'&menge='+q;
      var buy=c.querySelector('[data-calc-buy]');buy.hidden=!m.u;if(m.u)buy.href=m.u;
      c.classList.toggle("is-disc",pct>0);c.dataset.level=st.t;
    }
    tierBtns.forEach(function(tb){tb.addEventListener('click',function(){if(tb.hidden)return;st.t=tb.dataset.tier;render();});});
    r.addEventListener('input',function(){upd('r')});n.addEventListener('input',function(){upd('n')});b.addEventListener('change',function(){upd('n')});
    render();
  });
})();
